import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container mx-auto max-w-screen-2xl" }
const _hoisted_2 = { class: "flex w-full flex-wrap items-end pb-6" }
const _hoisted_3 = { class: "block" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "w-full sm:w-auto" }
const _hoisted_6 = { class: "rounded-3xl bg-sky-blue-200 p-6" }
const _hoisted_7 = {
  key: 1,
  class: "block h-8"
}
const _hoisted_8 = {
  key: 3,
  class: "mt-10 w-full text-center"
}

import { onMounted, computed } from "vue";
import { storeToRefs } from "pinia";

import { getTranslation } from "~/js/composables/translations";

import { Translations } from "~/js/interfaces/translations";
import { Facet, FacetCount } from "~/js/interfaces/facets";

import { useNewsStore } from "~/js/store/news";

import Grid from "~/vue/organisms/grids/GridLandings.vue";
import GridSkeleton from "~/vue/organisms/grids/GridSkeleton.vue";
import ButtonLoadMore from "~/vue/atoms/buttons/ButtonLoadMore.vue";
import TextH3 from "~/vue/atoms/texts/TextH3.vue";
import TextBody from "~/vue/atoms/texts/TextBody.vue";
import FilterMultiselect from "~/vue/molecules/filters/FilterMultiselect.vue";
import SvgLoader from "~/vue/atoms/svgs/SvgLoader.vue";

interface Props {
	translations?: Translations | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ViewNews',
  props: {
    translations: { default: null }
  },
  setup(__props: any) {

const props = __props;
const newsStore = useNewsStore();
const { news, loading, pagination, facets, filters } = storeToRefs(newsStore);

const onFetch = () => {
	newsStore.fetch();
};

const onLoadMore = () => {
	newsStore.fetch(false);
};

const yearFilter = computed(() => {
	let filteredFacet = facets.value.find((facet: Facet) => facet.field_name === "postDateYear");
	// const currentYear =  new Date().getFullYear()

	// if (filteredFacet) {
	//     filteredFacet.counts.forEach((count: FacetCount) => {
	//         if (count.value == currentYear) {
	//             count.value = `${getTranslation(props.translations,'Most recent')} (${new Date().getFullYear()})`
	//         }
	//     })
	// }

	return filteredFacet;
});

const updateFacet = (facet: string) => {
	newsStore.setFilter("date", facet);
};

onMounted(async () => {
	await onFetch();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, [
          _createVNode(TextH3, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(getTranslation)(__props.translations, "News posts")), 1)
            ]),
            _: 1
          })
        ]),
        _createVNode(TextBody, { utilities: "pb-0.5 lg:pb-1.5 grow" }, {
          default: _withCtx(() => [
            (!_unref(loading))
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(pagination).foundResults), 1))
              : _createCommentVNode("", true),
            (_unref(loading))
              ? (_openBlock(), _createBlock(SvgLoader, {
                  key: 1,
                  utilities: "mb-2"
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, [
          (yearFilter.value)
            ? (_openBlock(), _createBlock(FilterMultiselect, {
                key: 0,
                label: _unref(getTranslation)(props.translations, 'Select a year'),
                facet: yearFilter.value,
                loading: _unref(loading),
                translations: __props.translations,
                selected: _unref(filters).date.values,
                "dropdown-position": "right",
                utilities: "mt-4 md:mt-0",
                onSetFacet: _cache[0] || (_cache[0] = ($event: any) => (updateFacet($event)))
              }, null, 8, ["label", "facet", "loading", "translations", "selected"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_unref(news))
          ? (_openBlock(), _createBlock(Grid, {
              key: 0,
              items: _unref(news).map((news) => news.document)
            }, null, 8, ["items"]))
          : _createCommentVNode("", true),
        (_unref(loading))
          ? (_openBlock(), _createElementBlock("span", _hoisted_7))
          : _createCommentVNode("", true),
        (_unref(loading))
          ? (_openBlock(), _createBlock(GridSkeleton, {
              key: 2,
              size: _unref(pagination).itemsPerPage
            }, null, 8, ["size"]))
          : _createCommentVNode("", true),
        (_unref(pagination).current < _unref(pagination).totalPages)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_unref(pagination).current < _unref(pagination).totalPages)
                ? (_openBlock(), _createBlock(ButtonLoadMore, {
                    key: 0,
                    title: _unref(getTranslation)(__props.translations, 'Load more news posts'),
                    loading: _unref(loading),
                    ga: {
							category: 'news-load-more',
							action: 'click',
							label: _unref(pagination).current,
						},
                    utilities: "mx-auto",
                    onClick: onLoadMore
                  }, null, 8, ["title", "loading", "ga"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})